import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { typography } from "@mui/system";

export const StyledTextKey = styled("span")`
  font-size: 0.9rem;
  text-transform: capitalize;
  font-weight: bold;
`;
export const StyledTextValue = styled("span")`
  font-size: 1.2rem;
`;
export const StyledVariantBox = styled(Box)`
  cursor: pointer;
  padding: 0.2rem 0.8rem;
  margin: 0.2rem;
  border: ${(props) => "1px solid " + props.theme.palette.primary.main};
`;
export const StyledComment = styled(Typography)``;
export const StyledReviewerName = styled(Typography)`
  text-transform: capitalize;
  font-weight: bold;
`;
export const StyledReviewDate = styled(Typography)`
  font-size: 0.8rem;
`;
export const StyledAverageRatingBox = styled(Box)`
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.8rem !important;

  color: ${({ theme }) => theme.palette.primary.main};
  padding: 0.1rem;
  display: inline;
  vertical-align: middle;
  align-items: center;
`;
export const StyledProductTableLabel = styled(Typography)`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1rem;
`;
export const BottomFixedAddToCartButton = styled(Box)(
  ({ theme }) => `
  display: flex ;
  position: fixed;
  bottom: 0;
  background: #fff;
  left: 0;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  text-align: center;
  padding: 0.6rem 0.5rem;
  box-shadow: rgb(0 0 0 / 20%) 0px -4px 4px 0px;
 
  `
);
